export const notificationPriorities = [
  { label: "High", value: "HIGH" },
  { label: "Medium", value: "MEDIUM" },
  { label: "Low", value: "LOW" },
];

export const findDropdownValue = (value, options) => (
  options.find(v => v.value == value)
)
